// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"CategoriaClienteForm_inputForm__3TaIU"};